// components/AuthPage/LoginForm.jsx
import { useState } from "react";
import { loginUser } from "../../APIs/authApi";
import FloatingInput from "./FloatingInput";

export default function LoginForm({ onSuccess, onForgotPassword }) {
  const [form, setForm]   = useState({ username: "", password: "" });
  const [loading, setLoad] = useState(false);
  const [error, setError]  = useState(null);

  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoad(true); setError(null);
    try {
      const data = await loginUser(form);
      onSuccess?.(data);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        err.response?.data?.non_field_errors?.[0] ||
        "Invalid credentials. Please try again."
      );
    } finally { setLoad(false); }
  };

  return (
    <form onSubmit={onSubmit} className="animate-[fin_.3s_cubic-bezier(.16,1,.3,1)_both]">

      {/* Error */}
      {error && (
        <div className="mb-3 rounded-[9px] border border-red-500/20 bg-red-500/[.07] px-3 py-2.5 text-[12.5px] text-red-300/90 leading-[1.5]">
          {error}
        </div>
      )}

      <FloatingInput
        name="username" label="Username" type="text"
        value={form.username} onChange={onChange}
        required autoComplete="username"
        className="mb-3.5"
      />

      <FloatingInput
        name="password" label="Password" type="password"
        value={form.password} onChange={onChange}
        required autoComplete="current-password"
        className="mb-1"
      />

      {/* Forgot password */}
      <div className="flex justify-end mt-1 mb-1">
        <button
          type="button"
          onClick={() => onForgotPassword?.()}
          className="text-[11.5px] text-slate-500/70 hover:text-blue-400 transition-colors"
        >
          Forgot password?
        </button>
      </div>

      <AuthButton loading={loading} label="Sign In" loadingLabel="Authenticating…" />
    </form>
  );
}

/* ── Shared auth button ─────────────────────────── */
export function AuthButton({ loading, label, loadingLabel }) {
  return (
    <button
      type="submit"
      disabled={loading}
      className={[
        "mt-2 w-full rounded-[10px] py-[14px]",
        "text-[12.5px] font-semibold tracking-[.08em] uppercase text-white",
        "transition-all duration-300",
        "bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-600",
        "hover:-translate-y-[1px] hover:shadow-[0_8px_28px_rgba(37,99,235,0.35)]",
        "active:translate-y-0 active:shadow-none",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "relative overflow-hidden group",
      ].join(" ")}
    >
      {/* Shimmer sweep on hover */}
      <span className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500 bg-gradient-to-r from-transparent via-white/[.07] to-transparent" />

      <span className="relative flex items-center justify-center gap-2">
        {loading && (
          <svg
            className="animate-spin"
            width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"
          >
            <circle cx="12" cy="12" r="10" strokeOpacity=".25"/>
            <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/>
          </svg>
        )}
        {loading ? loadingLabel : label}
      </span>
    </button>
  );
}